var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tab',{attrs:{"lazy":"","title-item-class":"mb-1"}},[_c('template',{slot:"title"},[_vm._v("Diagnostics Referrals")]),_c('diagnostic-referrals-base',{attrs:{"button-top":"","small":"","callback":_vm.createPatientAdminDiagnostics}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }